import { TableDataQa } from 'commons/types/enums'
import { SortDirection, Table } from 'ui/components/Table'

import { useDocumentStatusReportContext } from '../../context/reportContext'
import { columns } from './columns'

export const ReportTable = () => {
  const {
    data: {
      availableSortFields,
      form: { page, size, sortBy, sortDesc },
      total,
      items
    },
    routeApi,
    isFetching
  } = useDocumentStatusReportContext()
  const navigate = routeApi.useNavigate()

  return (
    <Table
      columns={columns(availableSortFields)}
      dataSource={items.map((item) => ({ item }))}
      dataQa={TableDataQa.BP_REPORTS_DOCUMENT_STATUS}
      loading={isFetching}
      pagination={{
        page,
        size,
        onChange: (page, size) => {
          navigate({ to: '.', search: (prev) => ({ ...prev, page, size }) })
        },
        total
      }}
      sorting={{
        order: [
          {
            field: sortBy || '',
            direction: sortDesc ? 'DESC' : 'ASC'
          }
        ],
        onChange: ({ field, direction }) => {
          navigate({
            to: '.',
            search: (prev) => ({ ...prev, sortBy: field, sortDesc: direction === SortDirection.DESC })
          })
        }
      }}
    />
  )
}
